import { render, staticRenderFns } from "./AppVersionManager.vue?vue&type=template&id=1e61c7c4&"
import script from "./AppVersionManager.vue?vue&type=script&lang=js&"
export * from "./AppVersionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports